export const AUTH0_ROLES_CLAIM = "AIHR/Roles";
export const COSMOS_ACCESS_ROLE = "Cosmos";

export const parseAihrRoles = (raw: unknown): string[] => {
  if (Array.isArray(raw)) {
    return raw.filter((entry): entry is string => typeof entry === "string");
  }
  if (typeof raw === "string") {
    return raw
      .split(",")
      .map((entry) => entry.trim())
      .filter(Boolean);
  }
  return [];
};

export const hasCosmosAccess = (roles: string[]): boolean =>
  roles.includes(COSMOS_ACCESS_ROLE);
